import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask2600To2699Service {

  constructor() { }
}
